var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 9.345C11.6021 9.02431 9.35944 7.60419 8.98669 7.66938C8.81169 7.70044 8.67781 7.84963 8.3195 8.27706C8.15338 8.48709 7.97143 8.68411 7.77525 8.86637C7.41514 8.77921 7.06654 8.64999 6.73663 8.48137C5.44306 7.85159 4.39803 6.80625 3.76863 5.5125C3.60001 5.18258 3.47079 4.83398 3.38363 4.47388C3.56589 4.27769 3.76291 4.09575 3.97294 3.92963C4.39994 3.57131 4.54956 3.43831 4.58063 3.26244C4.64581 2.88881 3.22438 0.647063 2.905 0.264688C2.77113 0.106313 2.6495 0 2.49375 0C2.04225 0 0 2.52525 0 2.8525C0 2.87919 0.04375 5.50813 3.36394 8.88606C6.74188 12.2063 9.37081 12.25 9.3975 12.25C9.72475 12.25 12.25 10.2077 12.25 9.75625C12.25 9.6005 12.1437 9.47888 11.9844 9.345ZM9.1875 5.6875H10.0625C10.0613 4.7596 9.69222 3.87003 9.03609 3.2139C8.37997 2.55778 7.4904 2.18866 6.5625 2.1875V3.0625C7.25848 3.06319 7.92576 3.33998 8.41789 3.83211C8.91002 4.32424 9.1868 4.99152 9.1875 5.6875Z",
    fill: "white",
    fillOpacity: 0.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 5.6875H12.25C12.2483 4.17961 11.6485 2.73399 10.5823 1.66775C9.51601 0.601512 8.07039 0.00173686 6.5625 0V0.875C7.83839 0.876505 9.0616 1.38402 9.96379 2.28621C10.866 3.1884 11.3735 4.41161 11.375 5.6875Z",
    fill: "white",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.a136b4fb0c1043b5d373f718ef0e0af2.svg";
export { ForwardRef as ReactComponent };